export default "__VITE_ASSET__DR5v9NQ4__"